export const logColor = (color: string) => {
    return `color: ${color}`;
};
